import { PressEvent } from "react-aria-components";
import { Button } from "../Common/Buttons/Button";

interface ShareCustomObjectButtonProps {
  onPress: (_: PressEvent) => void;
  disabled: boolean;
}
export const ShareCustomObjectButton = ({
  onPress,
  disabled,
}: ShareCustomObjectButtonProps) => (
  <Button
    onPress={onPress}
    isDisabled={disabled}
    size="small"
    variant="outlineInverted"
    iconStart="mail"
    title="Share public profile"
  />
);
